var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('os-internal-users-overview',{staticClass:"minimal-critical-height",on:{"rowclicked":(e) => _vm.openExisting(e),"create":function($event){return _vm.openCreateForm()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }